import React from "react";

import "../../css/PaymentProcessStyle.scss";
import "./css/Step3dSecureVerificationStyle.scss";

export default function Step3dSecureVerification({ translation }) {
  return <div id="verification-container" style={{ height: '80vh' }}></div>
}